import * as React from "react";
import { Dropdown, Menu, Table } from "semantic-ui-react";
import { useContext } from "react";
import { PlayerCardTemplate } from "../../../../services/bedrock";
import { PlayerCardSettingsContext } from "../../Contexts";

interface PlayerCardTemplateRowProps {
  template: PlayerCardTemplate;
  isSelected: boolean;
  onDuplicateClick: (template: PlayerCardTemplate) => void;
}

const PlayerCardTemplateRow: React.FC<PlayerCardTemplateRowProps> = ({ template, isSelected, onDuplicateClick }) => {
  const { Templates, User } = useContext(PlayerCardSettingsContext);

  const selectTemplate = () => {
    if (Templates.selectedTemplate?.id === template.id) {
      Templates.setInEditMode(true);
    } else {
      Templates.setSelectedTemplate(template);
    }
  };

  const deleteTemplate = (template: PlayerCardTemplate) => {
    const confirmed = confirm("Are you sure you want to delete this template?");
    if (confirmed) Templates.deleteTemplate(template.id);
  };

  const editTemplate = () => {
    Templates.setSelectedTemplate(template);
    Templates.setInEditMode(true);
  };

  const actions: {
    key: string;
    content: string;
    handler: (template: PlayerCardTemplate) => void;
  }[] = [
    { key: "edit", content: "Edit", handler: editTemplate },
    { key: "duplicate", content: "Duplicate", handler: onDuplicateClick },
    { key: "delete", content: "Delete", handler: deleteTemplate },
  ];

  return (
    <Table.Row className={`selectableRow ${isSelected ? "selected" : ""}`} onClick={selectTemplate}>
      <Table.Cell>{template.name}</Table.Cell>
      <Table.Cell>
        {User.hasWritePermission && (
          <Menu className="actionsMenu">
            <Dropdown icon="ellipsis horizontal">
              <Dropdown.Menu>
                {actions.map(action => (
                  <Dropdown.Item key={action.key} content={action.content} onClick={() => action.handler(template)} />
                ))}
              </Dropdown.Menu>
            </Dropdown>
          </Menu>
        )}
      </Table.Cell>
    </Table.Row>
  );
};
export default PlayerCardTemplateRow;
